var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlfabank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.85156 12.6492H12.2644V14.3996H3.85156V12.6492ZM6.35396 8.51801H9.67236L10.2324 10.278H12.0724L9.58916 2.87961C9.34916 2.16921 9.07076 1.59961 8.12036 1.59961C7.16996 1.59961 6.87876 2.15961 6.62916 2.87961L4.03076 10.2748H5.75556L6.35396 8.51801ZM8.03716 3.51961H8.07876L9.19556 7.03961H6.85956L8.03716 3.51961Z",
    fill: "#EF3124"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlfabank);
export default ForwardRef;